export default "/images/69e7909747ff52ddc58ba01fb31a0775.png";